import { IS_PROTOTYPE } from '../../webinars/config';

// The webinar privacy notice's wording, approved by Kole Medical on 15 October 2026. Shown in the
// registration form's pop-up and on its own page (/events/privacy). One copy, so the two can't
// drift apart. When the wording changes, bump PRIVACY_NOTICE_VERSION (src/webinars/config.ts and
// the server's default in supabase/functions/_shared/config.ts).
const sections = [
  { heading: "What we collect", body: "Your name, email address, phone number, organisation and professional role." },
  { heading: "Why we collect it", body: "To register you, email your confirmation and joining link, and keep attendance records for the webinar." },
  { heading: "How it is stored and protected", body: "Details are stored securely and access is limited to authorised Kole Medical staff." },
  { heading: "Who can access it", body: "Only Kole Medical staff who administer webinars. We do not sell your information." },
  { heading: "Service providers", body: "Registrations are stored with our database provider (Supabase). Your name and email address are processed by our email provider (Resend) to send registration emails, and by Microsoft Teams when you join a session." },
  { heading: "Retention, access and correction", body: "We keep registration records only as long as needed. You can ask to see, correct or delete your information at any time." },
  { heading: "Marketing", body: "Registering does not sign you up for marketing. We only send news about future events if you opt in." },
  { heading: "Contact us", body: "Questions about your information: info@kolemedical.co.za" },
];

export default function PrivacyNoticeContent() {
  return (
    <>
      {IS_PROTOTYPE && (
        <p className="ev-privacy-prototype">
          In this prototype, details you enter are saved only in this browser and are not sent to Kole Medical.
        </p>
      )}
      <dl className="ev-privacy-list">
        {sections.map(section => (
          <div key={section.heading}>
            <dt>{section.heading}</dt>
            <dd>{section.body}</dd>
          </div>
        ))}
      </dl>
    </>
  );
}
